<!--Top Bar/School Selector-->
<div class="SchoolDiv">
	<h5 class="TitleHeading">School</h5>

	<div>
		<caass-schoolselector [ShowAll]="false"> </caass-schoolselector>
	</div>
</div>

<!--Main Grid-->
<div class="MainArea">
	<!--Student Attendance-->
	<div class="ItemBorder" style="min-width: min-content">
		<h5 class="TitleHeading">Student Attendance</h5>

		<div class="AttendanceFlex">
			<!--Left Col-->
			<div class="AttendanceColumn">
				<label>School Number:</label>
				<p>{{ SA_SchoolNumber }}</p>

				<label>Tardy:</label>
				<p>{{ SA_Tardy }}</p>

				<label>Absent:</label>
				<p>{{ SA_Absent }}</p>

				<label>On Time:</label>
				<p>{{ SA_OnTime }}</p>

				<label>Barcode Entries:</label>
				<p>{{ SA_BarcodeEntries }}</p>

				<label>Manual Entries:</label>
				<p>{{ SA_ManualEntries }}</p>

				<label>Class Attendance Entries:</label>
				<p>{{ SA_ClassAttendanceEntries }}</p>
			</div>

			<!--Right Col-->
			<div class="AttendanceColumn">
				<label>Total Suspension:</label>
				<p>{{ SA_TotalSuspensions }}</p>

				<label>Other Attendance Entries:</label>
				<p>{{ SA_OtherEntries }}</p>

				<label>Out-Of-School Suspensions:</label>
				<p>{{ SA_OutOfSchoolSuspensions }}</p>

				<label>In-School Suspensions:</label>
				<p>{{ SA_InSchoolSuspensions }}</p>

				<label>Early Release:</label>
				<p>{{ SA_EarlyRelease }}</p>

				<label>Percent Present:</label>
				<p>{{ SA_PercentPresent }}</p>

				<label>Percent Absent:</label>
				<p>{{ SA_PercentAbsent }}</p>
			</div>
		</div>
	</div>

	<!--Today's Events-->
	<div class="ItemBorder">
		<h5 class="TitleHeading">Today's Events</h5>

		<div>
			<!--Table-->
			<div>
				<p-table
					#mydt
					[scrollable]="true"
					scrollDirection="both"
					[value]="lstEvents"
					[loading]="EventLoading == true"
					[paginator]="true"
					[(rows)]="StudentAttendancePageRows"
					[(first)]="pagefirst"
					[showCurrentPageReport]="true"
					[resizableColumns]="false"
					sortMode="multiple"
					styleClass="p-datatable-striped"
					selectionMode="single"
					[(selection)]="SelectedEvent"
					dataKey="EventID"
					currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
					[rowsPerPageOptions]="[5, 10, 25, 50]"
				>
					<!--Headers-->
					<ng-template pTemplate="header">
						<!--Filter or Select from Dropdown-->
						<tr>
							<!--INSERT CUSTOM FILTERS HERE-->

							<!--EventDescShort-->
							<th>
								<p-columnFilter type="text" field="EventDescShort" matchMode="contains" [showMenu]="true"></p-columnFilter>
							</th>

							<!--EventDescLong-->
							<th>
								<p-columnFilter type="text" field="EventDescLong" matchMode="contains" [showMenu]="true"></p-columnFilter>
							</th>

							<!--EventLocation-->
							<th>
								<p-columnFilter type="text" field="EventLocation" matchMode="contains" [showMenu]="true"></p-columnFilter>
							</th>

							<!--DoorsOpenTime-->
							<th class="TimeColWidth">
								<!-- <p-columnFilter type="text" field="DoorsOpenTime" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
							</th>

							<!--StartTime-->
							<th class="TimeColWidth">
								<!-- <p-columnFilter type="text" field="StartTime" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
							</th>

							<!--EndTime-->
							<th class="TimeColWidth">
								<!-- <p-columnFilter type="text" field="EndTime" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
							</th>
						</tr>

						<!--Column Names-->
						<tr style="height: 4rem">
							<!--INSERT CUSTOM COLUMNS HERE-->
							<th pSortableColumn="EventDescShort">Name<p-sortIcon field="EventDescShort"></p-sortIcon></th>
							<th pSortableColumn="EventDescLong">Description<p-sortIcon field="EventDescLong"></p-sortIcon></th>
							<th pSortableColumn="EventLocation">Location<p-sortIcon field="EventLocation"></p-sortIcon></th>
							<th class="TimeColWidth" pSortableColumn="DoorsOpenTime">Doors Open Time<p-sortIcon field="DoorsOpenTime"></p-sortIcon></th>
							<th class="TimeColWidth" pSortableColumn="StartTime">Start Time<p-sortIcon field="StartTime"></p-sortIcon></th>
							<th class="TimeColWidth" pSortableColumn="EndTime">End Time<p-sortIcon field="EndTime"></p-sortIcon></th>
						</tr>
					</ng-template>

					<!--Data-->
					<ng-template pTemplate="body" let-Event>
						<tr [pSelectableRow]="Event">
							<td *ngFor="let col of EventCols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
								{{ Event[col.field] }}
							</td>

							<td
								class="TimeColWidth"
								*ngFor="let col of EventTimeCols"
								style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
							>
								{{ Event[col.field] }}
							</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
		</div>
	</div>

	<!--Today's Releases-->
	<div class="ItemBorder">
		<h5 class="TitleHeading">Today's Releases</h5>

		<div>
			<!--Table-->
			<div>
				<p-table
					#mydt
					[scrollable]="true"
					scrollDirection="both"
					[value]="lstReleases"
					[loading]="ReleaseLoading == true"
					[paginator]="true"
					[(rows)]="ReleasesPageRows"
					[(first)]="pagefirst"
					[showCurrentPageReport]="true"
					[resizableColumns]="false"
					sortMode="multiple"
					styleClass="p-datatable-striped"
					selectionMode="single"
					[(selection)]="SelectedRelease"
					dataKey="ReleaseScheduleID"
					currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
					[rowsPerPageOptions]="[5, 10, 25, 50]"
				>
					<!--Headers-->
					<ng-template pTemplate="header">
						<!--Filter or Select from Dropdown-->
						<tr>
							<th class="ImageColumnWidth"></th>

							<!--INSERT CUSTOM FILTERS HERE-->

							<!--StudentName-->
							<th>
								<p-columnFilter type="text" field="StudentName" matchMode="contains" [showMenu]="true"></p-columnFilter>
							</th>

							<!--ReleaseTypeDesc-->
							<th>
								<p-columnFilter field="ReleaseTypeDesc" matchMode="equals" [showMenu]="false">
									<ng-template pTemplate="filter" let-value let-filter="filterCallback">
										<p-dropdown
											appendTo="body"
											#filterReleaseTypeDesc
											[ngModel]="value"
											[options]="lstReleaseTypeDesc"
											(onChange)="filter($event.value)"
											placeholder="Any"
											[showClear]="true"
										>
											<ng-template let-value pTemplate="item">
												<span>{{ value }}</span>
											</ng-template>
										</p-dropdown>
									</ng-template>
								</p-columnFilter>
							</th>

							<!--ReleaseTime-->
							<th class="TimeColWidth">
								<!-- <p-columnFilter type="text" field="ReleaseTime" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
							</th>

							<!--Comment-->
							<th>
								<p-columnFilter type="text" field="Comment" matchMode="contains" [showMenu]="true"></p-columnFilter>
							</th>
						</tr>

						<!--Column Names-->
						<tr style="height: 4rem">
							<th class="ImageColumnWidth"></th>

							<!--INSERT CUSTOM COLUMNS HERE-->
							<th pSortableColumn="StudentName">Name<p-sortIcon field="StudentName"></p-sortIcon></th>
							<th pSortableColumn="ReleaseTypeDesc">Release Type<p-sortIcon field="ReleaseTypeDesc"></p-sortIcon></th>
							<th class="TimeColWidth" pSortableColumn="ReleaseTime">Time<p-sortIcon field="ReleaseTime"></p-sortIcon></th>
							<th pSortableColumn="Comment">Comments<p-sortIcon field="Comment"></p-sortIcon></th>
						</tr>
					</ng-template>

					<!--Data-->
					<ng-template pTemplate="body" let-Release>
						<tr [pSelectableRow]="Release">
							<td class="ImageColumnWidth" style="text-align: center">
								<img *ngIf="Release.PhotoData != ''" class="ts-Image" [src]="Release.PhotoData" />
							</td>

							<td *ngFor="let col of ReleaseCols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
								{{ Release[col.field] }}
							</td>

							<td class="TimeColWidth" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
								{{ Release.ReleaseTimeDesc }}
							</td>

							<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
								{{ Release.Comment }}
							</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
		</div>
	</div>

	<!--Today's Suspensions-->
	<div class="ItemBorder">
		<h5 class="TitleHeading">Today's Suspensions</h5>

		<div>
			<!--Suspension Type-->
			<div class="SuspensionTypeDiv">
				<label>Suspension Type:</label>
				<select
					[disabled]="SuspensionLoading"
					class="form-control"
					name="SuspensionTypeID"
					[(ngModel)]="SuspensionTypeID"
					(ngModelChange)="onSuspensionTypeChange($event)"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstSuspensionType" [ngValue]="o.ID">
						{{ o.Desc }}
					</option>
				</select>
			</div>

			<!--Table-->
			<div>
				<p-table
					#mydt
					[scrollable]="true"
					scrollDirection="both"
					[loading]="SuspensionLoading == true"
					[value]="lstSuspensions"
					[paginator]="true"
					[(rows)]="SuspensionPageRows"
					[(first)]="pagefirst"
					[showCurrentPageReport]="true"
					[resizableColumns]="false"
					sortMode="multiple"
					styleClass="p-datatable-striped"
					selectionMode="single"
					currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
					[rowsPerPageOptions]="[5, 10, 25, 50]"
				>
					<!--Headers-->
					<ng-template pTemplate="header">
						<!--Filter or Select from Dropdown-->
						<tr>
							<th style="width: 170px"></th>

							<th>
								<!--Filter student name text-->
								<p-columnFilter type="text" field="StudentName" matchMode="contains" [showMenu]="true"></p-columnFilter>
							</th>

							<th>
								<!--Filter student name text-->
								<p-columnFilter type="text" field="StudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
							</th>

							<th>
								<!--Suspension Type Desc-->
								<p-columnFilter field="SuspensionTypeDesc" matchMode="equals" [showMenu]="false">
									<ng-template pTemplate="filter" let-value let-filter="filterCallback">
										<p-dropdown
											appendTo="body"
											name="filterSuspensionTypeDesc"
											#filterSuspensionTypeDesc
											[ngModel]="value"
											[options]="lstSuspensionTypeDesc"
											(onChange)="filter($event.value)"
											placeholder="Any"
											[showClear]="true"
										>
											<ng-template let-value pTemplate="item">
												<span>{{ value }}</span>
											</ng-template>
										</p-dropdown>
									</ng-template>
								</p-columnFilter>
							</th>

							<th>
								<!--Suspension length Is Permanent-->
								<p-columnFilter field="IsPermanentDesc" matchMode="equals" [showMenu]="false">
									<ng-template pTemplate="filter" let-value let-filter="filterCallback">
										<p-dropdown
											appendTo="body"
											name="filterIsPermanentDesc"
											#filterIsPermanentDesc
											[ngModel]="value"
											[options]="lstIsPermanentDesc"
											(onChange)="filter($event.value)"
											placeholder="Any"
											[showClear]="true"
										>
											<ng-template let-value pTemplate="item">
												<span>{{ value }}</span>
											</ng-template>
										</p-dropdown>
									</ng-template>
								</p-columnFilter>
							</th>

							<th>
								<!--Infraction dropdown-->
								<p-columnFilter field="InfractionDesc" matchMode="equals" [showMenu]="false">
									<ng-template pTemplate="filter" let-value let-filter="filterCallback">
										<p-dropdown
											appendTo="body"
											name="filterInfractionDesc"
											#filterInfractionDesc
											[ngModel]="value"
											[options]="lstInfractionDesc"
											(onChange)="filter($event.value)"
											placeholder="Any"
											[showClear]="true"
										>
											<ng-template let-value pTemplate="item">
												<span>{{ value }}</span>
											</ng-template>
										</p-dropdown>
									</ng-template>
								</p-columnFilter>
							</th>
						</tr>

						<!--Column Names-->
						<tr style="height: 4rem">
							<th style="width: 170px"></th>
							<th pSortableColumn="StudentName">Student Name<p-sortIcon field="StudentName"></p-sortIcon></th>
							<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
							<th pSortableColumn="SuspensionTypeDesc">Suspension Type<p-sortIcon field="SuspensionTypeDesc"></p-sortIcon></th>
							<th pSortableColumn="SuspensionLength">Suspension Length<p-sortIcon field="SuspensionLength"></p-sortIcon></th>
							<th pSortableColumn="InfractionDesc">Infraction<p-sortIcon field="InfractionDesc"></p-sortIcon></th>
						</tr>
					</ng-template>

					<!--Data-->
					<ng-template pTemplate="body" let-suspension>
						<tr>
							<td style="width: 170px; text-align: center">
								<!-- <img *ngIf="suspension.PersonPhotoUrl != ''" class="ts-Image" src="{{suspension.PersonPhotoUrl}}">  -->
								<img *ngIf="suspension.PersonPhotoUrl != ''" class="ts-Image" [src]="suspension.PersonPhotoUrl" />
							</td>

							<td *ngFor="let col of SuspensionCols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
								{{ suspension[col.field] }}
							</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
		</div>
	</div>
</div>

<!--Bottom, Ads-->
<div class="OtherProductBorder">
	<h5 class="TitleHeading">Other Products by Morrison Consulting Inc.</h5>

	<div *ngIf="DashboardAdLoading == true" class="SpinnerDiv">
		<p-progressSpinner></p-progressSpinner>
	</div>

	<!--Items-->
	<div *ngIf="DashboardAdLoading == false" class="OtherProductMainArea">
		<div class="ProductCard" *ngFor="let ad of lstDashboardAd">
			<div class="ProductLogo">
				<a [href]="ad.DashboardAdLinkPath">
					<img style="max-height: 100px" [src]="ad.DashboardAdIconPath" [alt]="ad.DashboardAdAltText" />
				</a>
			</div>

			<div class="ProductDesc">
				<p class="ProductHeight">{{ ad.DashboardAdText }}</p>
				<br />
				<a class="ProductLink" [href]="ad.DashboardAdLinkPath" target="_blank">Read More</a>
			</div>
		</div>
	</div>
</div>
